import { Button } from "@/components/ui/button"
import {
  getActivitiesOfFirstWeek,
  getActivitiesOfNextWeek,
} from "@/modules/study/entities/groupActivitiesByWeekday"
import { useActivitiesStore } from "@/modules/study/stores/use-activities-store"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { useEffect } from "react"
import { startOfWeek, addDays, endOfWeek } from "date-fns"
import useGetActivities from "../../../queries/use-get-activities"
import { useWeeklyActivities } from "@/modules/study/stores/use-weekly-activities-store"

interface ActivitiesWeeklyActionsProps {
  scrollRef: React.RefObject<HTMLDivElement>
}

export default function ActivitiesWeeklyActions({ scrollRef }: ActivitiesWeeklyActionsProps) {
  const { isNextWeek, setIsNextWeek } = useWeeklyActivities()
  const { setActivities } = useActivitiesStore()

  const now = new Date()
  const startDate = startOfWeek(now, { weekStartsOn: 1 })
  const endDate = endOfWeek(addDays(startDate, 7), { weekStartsOn: 1 })

  const activitiesQuery = useGetActivities({
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  })

  useEffect(() => {
    if (activitiesQuery.status === "success") {
      setActivities(getActivitiesOfFirstWeek(activitiesQuery.data))
    }
  }, [activitiesQuery.status, activitiesQuery.data])

  const handleGoToNextWeek = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ left: 0, behavior: "smooth" })
    }

    if (activitiesQuery.data) {
      setIsNextWeek(!isNextWeek)
      setActivities(getActivitiesOfNextWeek(activitiesQuery.data))
    }
  }

  const handleGoToCurrentWeek = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ left: 0, behavior: "smooth" })
    }

    if (activitiesQuery.data) {
      setIsNextWeek(!isNextWeek)
      setActivities(getActivitiesOfFirstWeek(activitiesQuery.data))
    }
  }

  const handleOnClickNextweek = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -600, behavior: "smooth" })
    }
  }

  const handleOnClickBacktweek = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 600, behavior: "smooth" })
    }
  }

  return (
    <div className="hidden h-fit flex-row gap-2 self-center md:flex">
      <Button
        variant="ghost"
        className="text-md"
        onClick={isNextWeek ? handleGoToCurrentWeek : handleGoToNextWeek}
      >
        {isNextWeek ? "Volver a semana actual" : "Ir a próxima semana"}
      </Button>
      <div className="flex items-center gap-2">
        <button
          onClick={handleOnClickNextweek}
          className="rounded-full p-1 hover:bg-neutral-100 disabled:opacity-50 disabled:hover:bg-transparent"
        >
          <ChevronLeft size={26} />
        </button>
        <button
          onClick={handleOnClickBacktweek}
          className="rounded-full p-1 hover:bg-neutral-100 disabled:opacity-50 disabled:hover:bg-transparent"
        >
          <ChevronRight size={26} />
        </button>
      </div>
    </div>
  )
}
